"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CrossChainDepositor_instances, _CrossChainDepositor_crossChainContracts, _CrossChainDepositor_revealMode, _CrossChainDepositor_extraDataEncoder;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossChainDepositor = void 0;
/**
 * Implementation of the cross chain depositor proxy. This component is used to
 * reveal cross-chain deposits whose target chain is not the same as the L1
 * chain the tBTC system is deployed on.
 * @see {DepositorProxy} for reference.
 */
class CrossChainDepositor {
    constructor(crossChainContracts, revealMode = "L2Transaction") {
        _CrossChainDepositor_instances.add(this);
        _CrossChainDepositor_crossChainContracts.set(this, void 0);
        _CrossChainDepositor_revealMode.set(this, void 0);
        __classPrivateFieldSet(this, _CrossChainDepositor_crossChainContracts, crossChainContracts, "f");
        __classPrivateFieldSet(this, _CrossChainDepositor_revealMode, revealMode, "f");
    }
    /**
     * @returns The chain-specific identifier of the contract that will be
     *          used as the actual L1 depositor embedded in the deposit script.
     *          In this case, the depositor must be the L1BitcoinDepositor contract
     *          corresponding to the given L2 chain the deposit is targeting.
     *          This is because the L1BitcoinDepositor contract reveals the deposit to
     *          the Bridge contract (on L1) and transfers minted TBTC token to the
     *          target L2 chain once the deposit is processed.
     * @see {DepositorProxy#getChainIdentifier}
     */
    getChainIdentifier() {
        return __classPrivateFieldGet(this, _CrossChainDepositor_crossChainContracts, "f").l1BitcoinDepositor.getChainIdentifier();
    }
    /**
     * @returns Extra data for the cross-chain deposit script. Actually, this is
     *          the L2 deposit owner identifier took from the L2BitcoinDepositor
     *          contract.
     * @throws Throws if the L2 deposit owner cannot be resolved. This
     *         typically happens if the L2BitcoinDepositor operates with
     *         a read-only signer whose address cannot be resolved.
     */
    extraData() {
        const depositOwner = __classPrivateFieldGet(this, _CrossChainDepositor_crossChainContracts, "f").l2BitcoinDepositor.getDepositOwner();
        if (!depositOwner) {
            throw new Error("Cannot resolve L2 deposit owner");
        }
        return __classPrivateFieldGet(this, _CrossChainDepositor_instances, "m", _CrossChainDepositor_extraDataEncoder).call(this).encodeDepositOwner(depositOwner);
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * Reveals the given deposit depending on the reveal mode.
     * @see {CrossChainDepositorMode} for reveal modes description.
     * @see {DepositorProxy#revealDeposit}
     */
    revealDeposit(depositTx, depositOutputIndex, deposit, vault) {
        switch (__classPrivateFieldGet(this, _CrossChainDepositor_revealMode, "f")) {
            case "L2Transaction":
                return __classPrivateFieldGet(this, _CrossChainDepositor_crossChainContracts, "f").l2BitcoinDepositor.initializeDeposit(depositTx, depositOutputIndex, deposit, vault);
            case "L1Transaction":
                return __classPrivateFieldGet(this, _CrossChainDepositor_crossChainContracts, "f").l1BitcoinDepositor.initializeDeposit(depositTx, depositOutputIndex, deposit, vault);
        }
    }
}
exports.CrossChainDepositor = CrossChainDepositor;
_CrossChainDepositor_crossChainContracts = new WeakMap(), _CrossChainDepositor_revealMode = new WeakMap(), _CrossChainDepositor_instances = new WeakSet(), _CrossChainDepositor_extraDataEncoder = function _CrossChainDepositor_extraDataEncoder() {
    switch (__classPrivateFieldGet(this, _CrossChainDepositor_revealMode, "f")) {
        case "L2Transaction":
            return __classPrivateFieldGet(this, _CrossChainDepositor_crossChainContracts, "f").l2BitcoinDepositor.extraDataEncoder();
        case "L1Transaction":
            return __classPrivateFieldGet(this, _CrossChainDepositor_crossChainContracts, "f").l1BitcoinDepositor.extraDataEncoder();
    }
};
//# sourceMappingURL=cross-chain.js.map